const contactTranslations = {
  en: {
    back: "← Back to Home",
    eyebrow: "SUPPORT",
    title: "Contact Us",
    subtitle:
      "Have a question or need help? Send us a message and our support team will get back to you as soon as possible.",

    helpTitle: "How Can We Help?",
    helpDescription:
      "Reach out with questions about your account, subscription, studying, or technical support.",

    emailTitle: "Email",
    responseTime:
      "We typically respond within 1 business day.",

    supportHoursTitle: "Support Hours",
    supportDays: "Monday – Friday",
    supportHours:
      "9:00 AM – 5:00 PM Eastern Time",

    commonInquiriesTitle: "Common Inquiries",
    commonInquiries: [
      "Account & subscription questions",
      "Technical support",
      "Practice questions",
      "AI explanations",
      "Continuing education",
      "General feedback",
    ],

    helpNoteTitle: "We're here to help.",
    helpNoteText:
      "Please include as much detail as possible so we can assist you faster.",

    formTitle: "Send Us a Message",
    formDescription:
      "Complete the form below and we'll respond by email.",

    nameLabel: "Name",
    namePlaceholder: "Your name",

    emailLabel: "Email",
    emailPlaceholder: "your@email.com",

    subjectLabel: "Subject",
    selectSubject: "Select a subject",

    subjects: {
      account: "Account & Subscription",
      technical: "Technical Support",
      practice: "Practice Questions",
      ai: "AI Explanations",
      ce: "Continuing Education",
      feedback: "General Feedback",
      other: "Other",
    },

    messageLabel: "Message",
    messagePlaceholder:
      "Tell us how we can help...",

    sending: "Sending...",
    sendMessage: "Send Message",

    formFooter:
      "By submitting this form, your message will be sent to our support team.",

    validationError:
      "Please complete all fields before sending your message.",

    successMessage:
      "Your message has been sent successfully. Our support team will get back to you as soon as possible.",

    sendError:
      "Unable to send your message. Please try again.",

    bottomTitle: "ACE Massage Hub Support",
    bottomText:
      "Supporting your learning, exam preparation, and professional growth.",
  },

  zh: {
    back: "← 返回首页",
    eyebrow: "客户支持",
    title: "联系我们",
    subtitle:
      "有问题或需要帮助？请给我们留言，我们的支持团队会尽快回复您。",

    helpTitle: "我们可以如何帮助您？",
    helpDescription:
      "如果您对账户、订阅、学习或技术问题有任何疑问，请联系我们。",

    emailTitle: "电子邮箱",
    responseTime:
      "我们通常会在 1 个工作日内回复。",

    supportHoursTitle: "客服时间",
    supportDays: "星期一 – 星期五",
    supportHours:
      "美国东部时间 上午 9:00 – 下午 5:00",

    commonInquiriesTitle: "常见咨询",
    commonInquiries: [
      "账户和订阅问题",
      "技术支持",
      "练习题相关问题",
      "AI 智能解析",
      "继续教育课程",
      "一般意见和反馈",
    ],

    helpNoteTitle: "我们随时为您提供帮助。",
    helpNoteText:
      "请尽可能提供详细信息，以便我们更快地协助您解决问题。",

    formTitle: "给我们留言",
    formDescription:
      "请填写以下表格，我们将通过电子邮件回复您。",

    nameLabel: "姓名",
    namePlaceholder: "您的姓名",

    emailLabel: "电子邮箱",
    emailPlaceholder: "your@email.com",

    subjectLabel: "主题",
    selectSubject: "请选择主题",

    subjects: {
      account: "账户和订阅",
      technical: "技术支持",
      practice: "练习题",
      ai: "AI 智能解析",
      ce: "继续教育",
      feedback: "意见和反馈",
      other: "其他",
    },

    messageLabel: "留言内容",
    messagePlaceholder:
      "请告诉我们您需要什么帮助……",

    sending: "正在发送……",
    sendMessage: "发送留言",

    formFooter:
      "提交此表格后，您的留言将发送给我们的支持团队。",

    validationError:
      "请填写所有字段后再发送留言。",

    successMessage:
      "您的留言已成功发送。我们的支持团队会尽快回复您。",

    sendError:
      "无法发送您的留言，请稍后重试。",

    bottomTitle: "ACE Massage Hub 客户支持",
    bottomText:
      "为您的学习、考试准备和职业发展提供支持。",
  },

  es: {
    back: "← Volver al inicio",
    eyebrow: "SOPORTE",
    title: "Contáctanos",
    subtitle:
      "¿Tienes alguna pregunta o necesitas ayuda? Envíanos un mensaje y nuestro equipo de soporte te responderá lo antes posible.",

    helpTitle: "¿Cómo podemos ayudarte?",
    helpDescription:
      "Contáctanos si tienes preguntas sobre tu cuenta, suscripción, estudios o necesitas soporte técnico.",

    emailTitle: "Correo electrónico",
    responseTime:
      "Normalmente respondemos en un plazo de 1 día hábil.",

    supportHoursTitle: "Horario de soporte",
    supportDays: "Lunes – Viernes",
    supportHours:
      "9:00 AM – 5:00 PM, hora del Este",

    commonInquiriesTitle: "Consultas frecuentes",
    commonInquiries: [
      "Preguntas sobre cuenta y suscripción",
      "Soporte técnico",
      "Preguntas de práctica",
      "Explicaciones con IA",
      "Educación continua",
      "Comentarios generales",
    ],

    helpNoteTitle: "Estamos aquí para ayudarte.",
    helpNoteText:
      "Incluye todos los detalles posibles para que podamos ayudarte más rápidamente.",

    formTitle: "Envíanos un mensaje",
    formDescription:
      "Completa el siguiente formulario y te responderemos por correo electrónico.",

    nameLabel: "Nombre",
    namePlaceholder: "Tu nombre",

    emailLabel: "Correo electrónico",
    emailPlaceholder: "tu@email.com",

    subjectLabel: "Asunto",
    selectSubject: "Selecciona un asunto",

    subjects: {
      account: "Cuenta y suscripción",
      technical: "Soporte técnico",
      practice: "Preguntas de práctica",
      ai: "Explicaciones con IA",
      ce: "Educación continua",
      feedback: "Comentarios generales",
      other: "Otro",
    },

    messageLabel: "Mensaje",
    messagePlaceholder:
      "Cuéntanos cómo podemos ayudarte...",

    sending: "Enviando...",
    sendMessage: "Enviar mensaje",

    formFooter:
      "Al enviar este formulario, tu mensaje será enviado a nuestro equipo de soporte.",

    validationError:
      "Completa todos los campos antes de enviar tu mensaje.",

    successMessage:
      "Tu mensaje se ha enviado correctamente. Nuestro equipo de soporte te responderá lo antes posible.",

    sendError:
      "No se pudo enviar tu mensaje. Inténtalo de nuevo.",

    bottomTitle: "Soporte de ACE Massage Hub",
    bottomText:
      "Apoyando tu aprendizaje, preparación para el examen y crecimiento profesional.",
  },

  ru: {
    back: "← Вернуться на главную",
    eyebrow: "ПОДДЕРЖКА",
    title: "Связаться с нами",
    subtitle:
      "У вас есть вопрос или вам нужна помощь? Отправьте нам сообщение, и наша служба поддержки ответит вам как можно скорее.",

    helpTitle: "Чем мы можем помочь?",
    helpDescription:
      "Свяжитесь с нами по вопросам учетной записи, подписки, обучения или технической поддержки.",

    emailTitle: "Электронная почта",
    responseTime:
      "Обычно мы отвечаем в течение 1 рабочего дня.",

    supportHoursTitle: "Часы работы поддержки",
    supportDays: "Понедельник – Пятница",
    supportHours:
      "9:00 – 17:00 по восточному времени США",

    commonInquiriesTitle: "Частые вопросы",
    commonInquiries: [
      "Вопросы об учетной записи и подписке",
      "Техническая поддержка",
      "Практические вопросы",
      "Объяснения с помощью ИИ",
      "Непрерывное образование",
      "Общие отзывы",
    ],

    helpNoteTitle: "Мы готовы помочь.",
    helpNoteText:
      "Пожалуйста, предоставьте как можно больше подробностей, чтобы мы могли быстрее вам помочь.",

    formTitle: "Отправьте нам сообщение",
    formDescription:
      "Заполните форму ниже, и мы ответим вам по электронной почте.",

    nameLabel: "Имя",
    namePlaceholder: "Ваше имя",

    emailLabel: "Электронная почта",
    emailPlaceholder: "your@email.com",

    subjectLabel: "Тема",
    selectSubject: "Выберите тему",

    subjects: {
      account: "Учетная запись и подписка",
      technical: "Техническая поддержка",
      practice: "Практические вопросы",
      ai: "Объяснения с помощью ИИ",
      ce: "Непрерывное образование",
      feedback: "Общие отзывы",
      other: "Другое",
    },

    messageLabel: "Сообщение",
    messagePlaceholder:
      "Расскажите, чем мы можем вам помочь...",

    sending: "Отправка...",
    sendMessage: "Отправить сообщение",

    formFooter:
      "После отправки этой формы ваше сообщение будет передано нашей службе поддержки.",

    validationError:
      "Пожалуйста, заполните все поля перед отправкой сообщения.",

    successMessage:
      "Ваше сообщение успешно отправлено. Наша служба поддержки ответит вам как можно скорее.",

    sendError:
      "Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз.",

    bottomTitle: "Поддержка ACE Massage Hub",
    bottomText:
      "Поддерживаем ваше обучение, подготовку к экзамену и профессиональное развитие.",
  },
};

export default contactTranslations;